module.exports = __webpack_public_path__ + "media/application/images/2023/01_still-600x338-9cfe212a7cee5378ed726da754146e32.png";